<template>
  <div class="wrapper fora" v-if="statusMandato">
    
    <div class="topo-header centro so-tela">
      <div style="display: flex; align-items: center;">
        <botao-voltar class="voltar" nomeRota="StatusMandato" />
        <h1>Visualizar Status do Mandato</h1>
      </div>
            
      <div class="acoes-topo">       
        <router-link :to="{ name: 'StatusMandatoEdit', params: { id: statusMandato.id }}">
          <button class="btn-acao btn-editar" title="Editar">Editar</button>
        </router-link>
        
        <button class="btn-acao btn-excluir" title="Excluir" @click.prevent="modalExclusaoVisivel = true">Excluir</button>
      </div>
    </div>
    
    <div class="form centro">
      <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
      <div class="conteudo-cards">
        
        <!-- GRADE 1: DADOS BÁSICOS NO NOVO PADRÃO -->
        <div class="painel-dados" style="margin-bottom: 1.5rem;">
          <div class="secao-dados">
            <h2 class="secao-titulo">Informações do Status</h2>
            <div class="grade-dados">
              
              <!-- CÓDIGO (Ocupa 1/4) -->
              <div class="item-dado">
                <span class="item-rotulo">Código</span>
                <span class="item-valor">{{ statusMandato.codigo }}</span>                    
              </div>

              <!-- NOME (Ocupa 2/4) -->
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Nome</span>
                <span class="item-valor">{{ statusMandato.nome }}</span>                    
              </div>
              
              <!-- ATIVO (Ocupa 1/4) -->
              <div class="item-dado">
                <span class="item-rotulo">Ativo</span>
                <span class="item-valor">{{ statusMandato.ativo ? 'Sim' : 'Não' }}</span>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    
    <!-- MODAL DE EXCLUSÃO -->
    <div v-if="modalExclusaoVisivel" class="modal-exclusao">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo excluir este status do mandato?</h2>
          </div>
          <div class="modal-body">
            <p>Dados do Status:</p>
            <div class="dados">
              <div class="flexbox">
                <div class="texto-centralizado">
                  Código: <span>{{ statusMandato.codigo }}</span>
                </div>
                <div class="texto-centralizado">
                  Nome: <span>{{ statusMandato.nome }}</span>
                </div>
                <div class="texto-centralizado">
                  Ativo: <span>{{ statusMandato.ativo ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
            <button class="btn-cancelar-exclusao" @click="modalExclusaoVisivel = false">Não</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================================= -->

    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="statusMandato.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="statusMandato.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="statusMandato.created_at"
        :updated_at="statusMandato.updated_at"
      />
    </div>
  </div>
</template>

<script>
import BotaoVoltar from '../../components/BotaoVoltar.vue';
import Footer from '../../components/Footer.vue';
import { parseISO, format } from "date-fns";
import StatusMandatoApi from "../../services/StatusMandatoApi";
import MsgErroFormularios from "../MsgErroFormularios";

export default {
  name: "ExibirStatusMandato",
  props: {
    statusMandato: Object,
  },
  components: {
    BotaoVoltar,
    Footer,
    MsgErroFormularios,
  },
  data() {
    return {
      statusMandatoApi: new StatusMandatoApi(),
      modalExclusaoVisivel: false,
      erro: false,
      msgErros: null,
    };
  },
  methods: {
    formatarDataHora(value) {
      return format(parseISO(value), "dd/MM/yyyy 'às' HH:mm:ss");
    },
    
    async confirmarExclusao() {
      try {
        await this.statusMandatoApi.destroyStatusMandato(this.statusMandato.id);
        this.modalExclusaoVisivel = false;
        this.$router.push({ name: "StatusMandato" }); 
      } catch (err) {
        console.error("Erro ao excluir status do mandato:", err);
        
        // 1. Esconde a modal de confirmação
        this.modalExclusaoVisivel = false;
        
        // 2. Ativa o estado de erro
        this.erro = true;
        
        // 3. Define a mensagem de erro formatada
        this.msgErros = {
          statusMandato: "Não foi possível excluir este status do mandato. Pode estar vinculado a um mandato existente."
        };
        
        // 4. Rola a página suavemente para o topo para evidenciar o erro
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    
    // Método para fechar a caixa de erro
    fecharErro() {
      this.erro = false;
      this.msgErros = null;
    }
  },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    font-family: 'Karla', sans-serif;
}

/* BOTÕES DE AÇÃO NO TOPO */
.acoes-topo {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    .btn-acao {
      font-family: "Montserrat-Medium", sans-serif;
      font-size: 0.9rem;
      padding: 0.2rem 1rem;
      border-radius: 0.2rem;
      cursor: pointer;
      background: transparent;
      transition: 0.2s;
    }

    .btn-editar {
      color: #005516;
      border: #005516 solid 0.15rem;
    }

    .btn-editar:hover {
      color: white;
      background-color: #005516;
    }

    .btn-excluir {
      color: #d32f2f;
      border: #d32f2f solid 0.15rem;
    }

    .btn-excluir:hover {
      color: white;
      background-color: #d32f2f;
    }
  }

/* NOVOS ESTILOS DO SISTEMA DE CARDS (GRID) */
.painel-dados {
  display: grid;
  gap: 0.85rem;
  margin-top: 1.5rem;
}

.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

.secao-titulo {
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.4rem 0;
  border-bottom: 1px solid #e2eae4;
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 0.98rem;
  color: #0a4a22;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.grade-dados {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)); 
  gap: 0.85rem 1rem;
}

.item-dado {
  min-width: 0;
  padding: 0.4rem 0.6rem;
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.4rem;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.15rem 0;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem;
  line-height: 1.2;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.9rem;
  line-height: 1.3;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

.item-dado--span2 { grid-column: span 2; }
.item-dado--largo { grid-column: 1 / -1; }

/* ESTILOS DO MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 60%; 
    max-height: 90vh; 
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column; 
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header h2 {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: center;
      margin-top: 1rem;
      flex-shrink: 0; 
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto; 
      flex-grow: 1; 

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;
        
        .flexbox {
          display: grid;
          grid-template-columns: repeat(3, 1fr); 
          gap: 0.5rem 1.5rem; 
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word; 
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/*  ESTRUTURA GLOBAL E RESPONSIVIDADE */
.fora, 
.wrapper, 
.form, 
.form.centro, 
.topo-header {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

/* Espaçamento principal */
.fora {
  width: 100% !important; 
  max-width: 100% !important;  
  padding: 1.5rem 0 !important; 
  margin: 0 !important; 
  min-height: calc(100vh - 10rem);
}

.wrapper {
  padding: 1.5rem 0 !important; 
  margin: 0 auto !important;
  border: none !important;
}

/* Largura e centralização */
.form.centro,
.centro {
  width: 96vw !important;
  max-width: 96vw !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

/* Alinhamento do cabeçalho */
.topo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;

  h1 {
    font-family: "Montserrat-Medium";
    font-weight: bold;
    color: #ffa600;
    margin-left: 0.75rem;
    font-size: 1.8rem;
  }
}

/* AJUSTES PARA TELAS MENORES (Celulares e Tablets) */
@media screen and (max-width: 1065px) {  
  .form.centro,
  .centro {
    width: 90vw !important;
    max-width: 90vw !important;
  }

  .topo-header {
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    h1 {
      margin-left: 0;
      font-size: 1.5rem;
    }
  }

  .acoes-topo {
    flex-direction: column;
    width: 100%;
    
    .btn-novo-original, .btn-acao {
      width: 100%;
      justify-content: center;
    }
  }

  .grade-dados {
    grid-template-columns: 1fr;
  }

  .item-dado--span2 {
    grid-column: auto;
  }

  .modal-exclusao .modal-mask {
    width: 85%;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
  
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}
</style>